"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TtsConversationalConfigOutput = void 0;
const core = __importStar(require("../../core"));
const TtsConversationalModel_1 = require("./TtsConversationalModel");
const SupportedVoice_1 = require("./SupportedVoice");
const TtsOutputFormat_1 = require("./TtsOutputFormat");
const TtsOptimizeStreamingLatency_1 = require("./TtsOptimizeStreamingLatency");
const PydanticPronunciationDictionaryVersionLocator_1 = require("./PydanticPronunciationDictionaryVersionLocator");
exports.TtsConversationalConfigOutput = core.serialization.object({
    modelId: core.serialization.property("model_id", TtsConversationalModel_1.TtsConversationalModel.optional()),
    voiceId: core.serialization.property("voice_id", core.serialization.string().optional()),
    supportedVoices: core.serialization.property("supported_voices", core.serialization.list(SupportedVoice_1.SupportedVoice).optional()),
    agentOutputAudioFormat: core.serialization.property("agent_output_audio_format", TtsOutputFormat_1.TtsOutputFormat.optional()),
    optimizeStreamingLatency: core.serialization.property("optimize_streaming_latency", TtsOptimizeStreamingLatency_1.TtsOptimizeStreamingLatency.optional()),
    stability: core.serialization.number().optional(),
    speed: core.serialization.number().optional(),
    similarityBoost: core.serialization.property("similarity_boost", core.serialization.number().optional()),
    pronunciationDictionaryLocators: core.serialization.property("pronunciation_dictionary_locators", core.serialization.list(PydanticPronunciationDictionaryVersionLocator_1.PydanticPronunciationDictionaryVersionLocator).optional()),
});
